module.exports = __webpack_public_path__ + "static/coding_interactions_dynamic_2_dont-b6a2ac10517674605c04151388542f41.png";